// extracted by mini-css-extract-plugin
export default {"header":"styles_header__lMJhF","toran":"styles_toran__TMdWA","logo_container":"styles_logo_container__5CHCl","logo_link":"styles_logo_link__cwVUV"};